import { Box, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import DeleteBtn from "src/components/shared/DeleteBtn";
import UpdateBtn from "src/components/shared/UpdateBtn";
import { UNIT_LIST_CONVERT } from "src/constant";
import { convertIntMoney } from "src/helper/convertCurrency";
const commonCss = { textAlign: "center" };

export default function TempExportTableItem({ item, num, setProdPick, handleRemove }) {
  return (
    <TableRow>
      <TableCell sx={{ ...commonCss }}>{num}</TableCell>
      <TableCell sx={{ ...commonCss }}>
        <Box>
          <Typography sx={{ fontSize: "12px" }}>{item?.productName}</Typography>
          <Typography sx={{ fontSize: "10px" }}>({item?.productMolName})</Typography>
        </Box>
      </TableCell>
      <TableCell sx={{ ...commonCss }}>{item?.batchName?.batch?.code ?? item?.batchName}</TableCell>
      <TableCell sx={{ ...commonCss }}>
        {item?.qtyCal} {item?.unit && `(${UNIT_LIST_CONVERT[item?.unit]})`}
      </TableCell>
      <TableCell sx={{ ...commonCss }}>{item?.discount}</TableCell>
      <TableCell sx={{ ...commonCss }}>
        <Typography sx={{ whiteSpace: "nowrap", fontSize: "12px" }}>{!!item?.tempPrice ? convertIntMoney(item?.tempPrice) + " đ" : 0}</Typography>
      </TableCell>
      <TableCell sx={{ ...commonCss }}>
        <Typography sx={{ whiteSpace: "nowrap", fontSize: "12px" }}>{convertIntMoney(item?.tempPrice * Number(item?.qtyCal) * (1 - item?.discount / 100) ?? 0)} đ</Typography>
      </TableCell>
      <TableCell sx={{ ...commonCss }}>
        <Box
          display="flex"
          gap="4px"
          justifyContent="center"
        >
          <UpdateBtn
            disabled={Number(item?.qtyCal) === Number(item?.exportedQty ?? 0)}
            handleUpdate={() => setProdPick({ ...item, mode: "update" })}
          />
          <DeleteBtn handleDelete={() => handleRemove(item?.productModelId, item?.transferDetailId)} />
        </Box>
      </TableCell>
    </TableRow>
  );
}
